(function (angular, _, $, viewport, Cookies, window) {
    'use strict';
    window.THF.Angular.JoinForm.controller('JoinForm', [
        '$scope',
        'ngDialog',
        'rebateFormWindow',
        'submitApplication',
        'FieldOptionsModel',
        'thfValidateItems',
        'thfFieldDefinitionCover',
        'thfFieldDefinitionEligibility',
        'thfFieldDefinitionPersonal',
        'thfFieldDefinitionContact',
        'thfFieldDefinitionPayment',
        'thfFieldDefinitionConfirm',
        function ($scope,
                  ngDialog,
                  rebateFormWindow,
                  submitApplication,
                  FieldOptionsModel,
                  thfValidateItems,
                  thfFieldDefinitionCover,
                  thfFieldDefinitionEligibility,
                  thfFieldDefinitionPersonal,
                  thfFieldDefinitionContact,
                  thfFieldDefinitionPayment,
                  thfFieldDefinitionConfirm) {

            var dataLoaded = false;

            $scope.apiSettings = joinFormPageData.apiSettings;
            /*{
             groupCode: 'DD003',
             agentCode: 'THESBOJ',
             locationCode: 'THF',
             siteCode: 'THF'
             };*/

            $scope.successState = {
                transactionId: '',
                memberId: ''
            };

            $scope.formState = {
                tab: 'eligibility',
                applicationId: null,
                siteName: joinFormPageData.siteName,
                sitePhone: joinFormPageData.sitePhone,
                troubleshootingPhoneNumber: joinFormPageData.troubleshootingPhoneNumber,
                appTimeout: joinFormPageData.appTimeout,
                turnOnAdalyserOnSubmit:  joinFormPageData.turnOnAdalyserOnSubmit,
                /**
                 * Used for specialised validation that is called when data is entered into the field,
                 * effectively a pre validation, this is then confirmed against the validation rule for
                 * thfPreValidated, NOTE: this can only be used for non repeating fields, E.G not within
                 * the dependants section.
                 *
                 * If I had time I would have re-written the way the fields worked.
                 */
                validation: {},
                display: {
                    form: false,
                    resumeApplication: false,
                    quotePanel: false,
                    loading: false,
                    loadingSubmission: false,
                    loadingSave: false,
                    loadingResume: false,
                    loadingForm: true,
                    loadingRebate: false,
                    thankYou: false
                },
                coverColours: {
                    hospital: '#F7F7F7',
                    extras: '#F7F7F7'
                },
                icon: {
                    single: { src: window.THF.SiteSettings.svgSprite+'#ui-single', viewBox: '0 0 20 26' },
                    couple: { src: window.THF.SiteSettings.svgSprite+'#ui-couple', viewBox: '0 0 40 26' },
                    family: { src: window.THF.SiteSettings.svgSprite+'#ui-family', viewBox: '0 0 40 23.99' },
                    singleParent: { src: window.THF.SiteSettings.svgSprite+'#ui-single-parent', viewBox: '0 0 27.83 26' },
                    tooltip: { src: window.THF.SiteSettings.svgSprite+'#ui-tooltip', viewBox: '0 0 32 32' },
                    checkboxDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-checkbox-default', viewBox: '0 0 32 32.01' },
                    checkboxChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-checkbox-selected', viewBox: '0 0 32 32.01' },
                    radialDefault: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-default', viewBox: '0 0 32 32.01' },
                    radialChecked: { src: window.THF.SiteSettings.svgSprite+'#ui-radial-filled', viewBox: '0 0 32 32.01' },
                    time: { src: window.THF.SiteSettings.svgSprite+'#ui-request-appointment', viewBox: '0 0 32 31.99' },
                    add: { src: window.THF.SiteSettings.svgSprite+'#ui-add', viewBox: '0 0 32 32' },
                    remove: { src: window.THF.SiteSettings.svgSprite+'#ui-not-applicable', viewBox: '0 0 19.98 19.94' },
                    right: { src: window.THF.SiteSettings.svgSprite+'#ui-right', viewBox: '0 0 11.99 22.52' },
                    tick: { src: window.THF.SiteSettings.svgSprite+'#ui-covered', viewBox: '0 0 20.01 15.93' },
                    invalid: { src: window.THF.SiteSettings.svgSprite+'#ui-not-applicable', viewBox: '0 0 19.98 19.94' },
                    edit: { src: window.THF.SiteSettings.svgSprite+'#ui-edit', viewBox: '0 0 31.98 32' },
                    andSymbol: { src: window.THF.SiteSettings.svgSprite+'#ui-and', viewBox: '0 0 24.01 28' },
                    down: { src: window.THF.SiteSettings.svgSprite+'#ui-down', viewBox: '0 0 22.52 11.99' },
                    up: { src: window.THF.SiteSettings.svgSprite+'#ui-up', viewBox: '0 0 22.52 11.99' },
                    legendCovered: { src: window.THF.SiteSettings.svgSprite+'#ui-legend-covered', viewBox: '0 0 22.52 11.99' },
                    legendNotCovered: { src: window.THF.SiteSettings.svgSprite+'#ui-legend-not-covered', viewBox: '0 0 22.52 11.99' },
                    legendRestricted: { src: window.THF.SiteSettings.svgSprite+'#ui-legend-restricted', viewBox: '0 0 22.52 11.99' }
                    
                }
            };

            $scope.submit = function ($event, sendApplication) {
                $event.preventDefault();
                if (validateTab('confirm', true)) {
                    document.cookie = "formOpened=true;"
                    submitApplication($scope, sendApplication);
                }
                else{
                    $scope.setFocusToInvalidField('confirm');
                }
            };

            $scope.showThankYou = function ($event, idObject) {
                $scope.formState.display.resumeApplication = false;
                $scope.formState.display.form = false;
                $scope.formState.display.quotePanel = false;
                $scope.formState.display.loading = false;
                $scope.formState.display.thankYou = true;

                if (typeof idObject !== 'undefined') {
                    $scope.successState.transactionId = false;
                    $scope.successState.memberId = false;
                    if (idObject.transactionId) {
                        $scope.successState.transactionId = idObject.transactionId;
                    }
                    else if (idObject.memberId) {
                        $scope.successState.memberId = idObject.memberId;
                    }
                }
            };

            /**
             * This is used for determining the state of the tabs as
             * well as the order of the tabs that appear as well.
             *
             * @type {object}
             */
            $scope.tabs = {
                eligibility: {
                    active: true,
                    hasData: false,
                    error: false,
                    labelNumber: '01',
                    labelText: joinFormPageData.tabInfo.eligibility.label,
                    introduction: joinFormPageData.tabInfo.eligibility.intro,
                    importantNote: joinFormPageData.tabInfo.eligibility.importantNote,
                    pageActions: {
                        backButton: false,
                        nextButton: false,
                        submitButton: false,
                        saveProgress: false,
                        saveButton: false
                    }
                },
                cover: {
                    active: false,
                    hasData: false,
                    error: false,
                    labelNumber: '02',
                    labelText: joinFormPageData.tabInfo.cover.label,
                    introduction: joinFormPageData.tabInfo.cover.intro,
                    pageActions: {
                        backButton: true,
                        nextButton: true,
                        submitButton: false,
                        saveProgress: false
                    }
                },
                personal: {
                    active: false,
                    hasData: false,
                    error: false,
                    labelNumber: '03',
                    labelText: joinFormPageData.tabInfo.personal.label,
                    introduction: joinFormPageData.tabInfo.personal.intro,
                    pageActions: {
                        backButton: true,
                        nextButton: true,
                        submitButton: false,
                        saveProgress: true,
                        saveButton: false
                    }
                },
                contact: {
                    active: false,
                    hasData: false,
                    error: false,
                    labelNumber: '04',
                    labelText: joinFormPageData.tabInfo.contact.label,
                    introduction: joinFormPageData.tabInfo.contact.intro,
                    pageActions: {
                        backButton: true,
                        nextButton: true,
                        submitButton: false,
                        saveProgress: true,
                        saveButton: false
                    }
                },
                payment: {
                    active: false,
                    hasData: false,
                    error: false,
                    labelNumber: '05',
                    labelText: joinFormPageData.tabInfo.payment.label,
                    introduction: joinFormPageData.tabInfo.payment.intro,
                    pageActions: {
                        backButton: true,
                        nextButton: true,
                        submitButton: false,
                        saveProgress: true,
                        saveButton: false
                    }
                },
                confirm: {
                    active: false,
                    hasData: false,
                    error: false,
                    labelNumber: '06',
                    labelText: joinFormPageData.tabInfo.confirm.label,
                    introduction: joinFormPageData.tabInfo.confirm.intro,
                    pageActions: {
                        backButton: true,
                        nextButton: false,
                        submitButton: true,
                        saveProgress: true,
                        saveButton: false
                    }
                }
            };

            $scope.field = {
                'eligibility': thfFieldDefinitionEligibility,
                'cover': thfFieldDefinitionCover,
                'personal': thfFieldDefinitionPersonal,
                'contact': thfFieldDefinitionContact,
                'payment': thfFieldDefinitionPayment,
                'confirm': thfFieldDefinitionConfirm
            };

            $scope.defaultModelValues = {};

            $scope.model = {
                eligibility: {},
                cover: {},
                personal: {
                    partner: {},
                    dependants: []
                },
                contact: {},
                payment: {},
                confirm: {}
            };

            $scope.validation = {
                eligibility: {},
                cover: {},
                personal: {
                    partner: {},
                    dependants: []
                },
                contact: {},
                payment: {},
                confirm: {}
            };

            $scope.validationRules = {
                eligibility: {},
                cover: {},
                personal: {
                    partner: {},
                    dependants: []
                },
                contact: {},
                payment: {},
                confirm: {}
            };

            $scope.quotePanel = {};

            $scope.displayGroups = {
                extendedCoverCheckbox: false,
                emergencyAmbulance: true,
                hospitalExtrasCover: true,

                eligibilityUnionsDropdown: false,
                eligibilityFormerMember: false,
                eligibilityFamilyMember: false,
                eligibilityNotQualified: false,

                partnerFields: false,
                rebateLevel: false,
                continuousCoverMember: false,
                continuousCoverPartner: false,
                medicareInfo: false,

                memberPreviousPolicyAllSame: false,

                memberPreviousPolicySwitching: true,
                memberPreviousPolicyFields: false,

                partnerPreviousPolicy: false,
                partnerPreviousPolicySwitching: false,
                partnerPreviousPolicyFields: false,

                dependants: [],

                dependantFields: false,
                dependantFullTimeStudent: false,
                postalAddress: true,
                benefits: true,

                howDidYouHearSpecify: false,

                rebateLoader: false,
                rebateError: false

            };

            /**
             * Used for the rendering of the confirmation table.
             */
            $scope.confirmTable = {
                eligibility: {
                    labelNumber: '01',
                    labelText: 'Eligibility',
                    rows: []
                },
                cover: {
                    labelNumber: '02',
                    labelText: 'Cover',
                    rows: []
                },
                personal: {
                    labelNumber: '03',
                    labelText: 'Personal Details',
                    rows: []
                },
                contact: {
                    labelNumber: '04',
                    labelText: 'Contact Details',
                    rows: []
                },
                payment: {
                    labelNumber: '05',
                    labelText: 'Payment Details',
                    rows: []
                }
            };

            $scope.modelMigration = function modelMigration(model) {
                if(typeof model.personal.memberContinuousCover === 'undefined' && typeof model.cover.memberContinuousCover !== 'undefined') {
                    model.personal.memberContinuousCover = model.cover.memberContinuousCover;
                    delete model.cover.memberContinuousCover;
                }
                if(typeof model.personal.partnerContinuousCover === 'undefined' && typeof model.cover.partnerContinuousCover !== 'undefined') {
                    model.personal.partnerContinuousCover = model.cover.partnerContinuousCover;
                    delete model.cover.partnerContinuousCover;
                }
                return model;
            };

            /**
             * Constructor / Initialiser / Starting Point.
             */
            function init(data) {
                setupForm();
                $scope.model = angular.copy($scope.defaultModelValues);
                hasApplicationId();
                setFieldOptions(data);
                loadLiveQuoteToolCookieData();
                tempLoadCookieData();
                $scope.detectTabsWithData();
                setDisplayState();
                ensureStarterpakSelectsCorrectly();
                $scope.ensureCoverStartDateIsCurrent();

                // If the link is from an emergency ambulance link.
                if (isEmergencyAmbulanceLink()) {
                    $scope.model.cover.emergencyAmbulance = 'Y';
                }

                // If the cover tab has all the data required then we show the quote panel.
                if (validateTab('cover', false)) {
                    $scope.calculateQuote(function () {
                        $scope.formState.display.quotePanel = true;
                    });
                }
            }

            function ensureStarterpakSelectsCorrectly() {
                if ($scope.model.cover.hospitalCover === 'SP') {
                    $scope.model.cover.extrasCover = 'SPAnc';
                }
            }

            /**
             * Detects if the page has an application id and then sets the application settings up appropriately.
             */
            function hasApplicationId() {
                var appId = THF.Utility.Location.queryParam('id');
                if (appId !== '') {
                    $scope.formState.applicationId = appId;
                    return true;
                }
                return false;
            }

            function isEmergencyAmbulanceLink() {
                var emergencyAmbulance = THF.Utility.Location.queryParam('emergencyAmbulance');
                if (emergencyAmbulance !== '') {
                    return true;
                }
                return false;
            }

            function setDisplayState() {
                if ($scope.formState.applicationId !== null) {
                    $scope.formState.display.form = false;
                    $scope.formState.display.resumeApplication = true;
                }
                else {
                    $scope.formState.display.form = true;
                    $scope.formState.display.resumeApplication = false;
                }
            }

            $scope.showForm = function () {
                $scope.formState.display.resumeApplication = false;
                $scope.formState.display.thankYou = false;
                $scope.formState.display.form = true;
            };

            $scope.ensureCoverStartDateIsCurrent = function () {
                var REGEX = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
                if (REGEX.test($scope.model.cover.coverStartDate)) {
                    var currentDate = moment().hour(0).minutes(0).second(0);
                    var coverStartDate = moment($scope.model.cover.coverStartDate).hour(0).minutes(0).second(0);
                    var initialDeductionDate = moment($scope.model.payment.paymentInitialDeductionDate).hour(0).minutes(0).second(0);

                    if (coverStartDate.isBefore(currentDate)) {
                        $scope.model.cover.coverStartDate = currentDate.format('YYYY-MM-DD');
                        coverStartDate = moment($scope.model.cover.coverStartDate).hour(0).minutes(0).second(0);
                    }

                    if (initialDeductionDate.isBefore(coverStartDate)) {
                        $scope.model.payment.paymentInitialDeductionDate = $scope.model.cover.coverStartDate;
                    }
                }
            };

            $scope.$watch('model', function (newValue, oldValue) {
                debugLog('Model Update');

                // Actions
                hideShowFormFields(newValue, oldValue);
                updateLabels(newValue, oldValue);
                updateLinkedValues(newValue, oldValue);
                updateValidationRules(newValue, oldValue);
                updateFieldOptions(newValue, oldValue);
            }, true);

            function updateLinkedValues(newValue, oldValue) {
                if (newValue.payment.paymentFrequency !== oldValue.payment.paymentFrequency) {
                    $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(newValue.cover.coverStartDate).add(1, 'month').toDate();
                    if ($scope.model.payment.paymentFrequency === 'Fortnightly') {
                        $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(newValue.cover.coverStartDate).add(2, 'weeks').toDate();
                    }
                }

                if (newValue.cover.coverStartDate !== oldValue.cover.coverStartDate) {
                    // Update the initial deduction fields.

                    if (moment(newValue.cover.coverStartDate).isBefore(moment().add(5, 'days'))) {
                        $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.minDate = moment(moment().add(5, 'days')).toDate();
                        $scope.model.payment.paymentInitialDeductionDate = moment().add(5, 'days').format('YYYY-MM-DD');
                    }
                    else {
                        $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.minDate = moment(newValue.cover.coverStartDate).toDate();
                    }
                    $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(newValue.cover.coverStartDate).add(1, 'month').toDate();
                    if ($scope.model.payment.paymentFrequency === 'Fortnightly') {
                        $scope.field.payment.paymentInitialDeductionDate.datePickerOptions.maxDate = moment(newValue.cover.coverStartDate).add(2, 'weeks').toDate();
                    }

                    // Update the dependants datepicker options.
                    $scope.field.personal.dependantDOB.datePickerOptions.minDate = moment(newValue.cover.coverStartDate).subtract(joinFormPageData.dependantMaxAge, 'years').subtract(1, 'day').toDate();

                    if ($scope.model.payment.paymentInitialDeductionDate < $scope.model.cover.coverStartDate) {
                        $scope.model.payment.paymentInitialDeductionDate = $scope.model.cover.coverStartDate;
                    }
                }

                var result;
                if (newValue.cover.hospitalCover !== oldValue.cover.hospitalCover) {
                    if (newValue.cover.hospitalCover === 'SP') {
                        $scope.model.cover.extrasCover = 'SPAnc';
                    }
                    else if (newValue.cover.extrasCover === 'SPAnc' && oldValue.cover.hospitalCover === 'SP') {
                        $scope.model.cover.extrasCover = 'EHC';
                    }

                    result = _.find($scope.field.cover.hospitalCover.options, {value: $scope.model.cover.hospitalCover});
                    if (typeof result === 'object' && result.colour && result.colour.main) {
                        $scope.formState.coverColours.hospital = result.colour.main;
                    }
                }

                if (newValue.cover.extrasCover !== oldValue.cover.extrasCover) {
                    if (newValue.cover.extrasCover === 'SPAnc') {
                        $scope.model.cover.hospitalCover = 'SP';
                    }
                    else if (newValue.cover.hospitalCover === 'SP' && oldValue.cover.extrasCover === 'SPAnc') {
                        $scope.model.cover.hospitalCover = 'BasHo';
                    }

                    // Update the extras colours
                    result = _.find($scope.field.cover.extrasCover.options, {value: $scope.model.cover.extrasCover});
                    if (typeof result === 'object' && result.colour && result.colour.main) {
                        $scope.formState.coverColours.extras = result.colour.main;
                    }
                }
            }

            /**
             * Setup the default values for the entire form.
             */
            function setupForm() {
                var validationRules = angular.copy($scope.validationRules);
                var defaults = angular.copy($scope.model);
                var tabName, tabFields, fieldName, field;
                for (tabName in $scope.field) {
                    if ($scope.field.hasOwnProperty(tabName)) {
                        tabFields = $scope.field[tabName];
                        for (fieldName in tabFields) {
                            if (tabFields.hasOwnProperty(fieldName)) {
                                field = tabFields[fieldName];

                                var model;
                                var rules;
                                if (typeof field.modelChild !== 'undefined') {
                                    if (defaults[tabName][field.modelChild] instanceof Array) {
                                        if (defaults[tabName][field.modelChild].length === 0) {
                                            defaults[tabName][field.modelChild].push({});
                                        }
                                        model = defaults[tabName][field.modelChild][0];
                                    }
                                    else {
                                        model = defaults[tabName][field.modelChild];
                                    }

                                    if (validationRules[tabName][field.modelChild] instanceof Array) {
                                        if (validationRules[tabName][field.modelChild].length === 0) {
                                            validationRules[tabName][field.modelChild].push({});
                                        }
                                        rules = validationRules[tabName][field.modelChild][0];
                                    }
                                    else {
                                        rules = validationRules[tabName][field.modelChild];
                                    }
                                }
                                else {
                                    model = defaults[tabName];
                                    rules = validationRules[tabName];
                                }

                                model[field.name] = field.defaultValue;
                                rules[field.name] = field.validation;
                            }
                        }
                    }
                }
                $scope.defaultModelValues = defaults;
                $scope.defaultValidationRules = validationRules;
                $scope.validationRules = angular.copy($scope.defaultValidationRules);
            }

            /**
             * Loads the data from the save method from the cookie.
             */
            function tempLoadCookieData() {
                // Only load this data if the live quote tool data is not present.
                if (!dataLoaded) {
                    var modelData = Cookies.getJSON('thfJoinForm');
                    if (typeof modelData !== 'undefined') {
                        $scope.model = $.extend(true, {}, $scope.model, modelData);
                    }
                }
            }

            function loadLiveQuoteToolCookieData() {
                var lqtData = Cookies.getJSON('thf-live-quote-tool');
                if (typeof lqtData !== 'undefined') {
                    var productData = THF.Utility.HealthRateCode.decode(lqtData.healthRateCode);
                    if (typeof productData === 'object') {
                        dataLoaded = true;
                        $scope.model.cover.primaryState = productData.state;
                        if (productData.membershipType === 'FamX') {
                            $scope.model.cover.memberType = 'Fam';
                            $scope.model.cover.nonStudentDependant = 'Y';
                        }
                        else if (productData.membershipType === 'SPFamX') {
                            $scope.model.cover.memberType = 'SPFam';
                            $scope.model.cover.nonStudentDependant = 'Y';
                        }
                        else {
                            $scope.model.cover.memberType = productData.membershipType;
                        }
                        if (productData.hospitalCover === '') {
                            $scope.model.cover.hospitalCover = 'NOHOSPITAL';
                        }
                        else {
                            $scope.model.cover.hospitalCover = productData.hospitalCover;
                        }

                        if (productData.ancillaryCover === '') {
                            $scope.model.cover.extrasCover = 'NOEXTRAS';
                        }
                        else {
                            $scope.model.cover.extrasCover = productData.ancillaryCover;
                        }

                        $scope.model.cover.medicareEligibility = 'Y';
                        $scope.model.cover.governmentRebate = 'Y';
                        $scope.model.cover.governmentRebateIncomeTier = lqtData.rebateTier;

                        // Set the frequency
                        var frequencyOption = _.find($scope.field.payment.paymentFrequency.options, {value: lqtData.frequency});
                        if (typeof frequencyOption !== 'undefined') {
                            $scope.model.payment.paymentFrequency = lqtData.frequency;
                        }

                        $scope.ensureCoverStartDateIsCurrent();
                    }
                }
            }

            $scope.detectTabsWithData = function (tabName) {
                var defaults = $scope.defaultModelValues;
                var k;
                if (typeof tabName !== 'undefined') {
                    if (typeof $scope.tabs[tabName] !== 'undefined' && typeof $scope.model[tabName] !== 'undefined' && typeof defaults[tabName] !== 'undefined') {
                        if (!angular.equals(defaults[tabName], $scope.model[tabName])) {
                            $scope.tabs[tabName].hasData = true;
                        }
                    }
                }
                else {
                    for (k in $scope.tabs) {
                        if ($scope.tabs.hasOwnProperty(k)) {
                            if (typeof $scope.model[k] !== 'undefined' && typeof defaults[k] !== 'undefined') {
                                if (!angular.equals(defaults[k], $scope.model[k])) {
                                    $scope.tabs[k].hasData = true;
                                }
                            }
                        }
                    }
                }
            }

            function isSingle() {
                return ($scope.model.cover.memberType === 'Sgl');
            }

            function isFamily() {
                return ($scope.model.cover.memberType === 'Fam');
            }

            function isSingleParent() {
                return ($scope.model.cover.memberType === 'SPFam');
            }

            function isCouple() {
                return ($scope.model.cover.memberType === 'Cpl');
            }


            function updateLabels(newValue, oldValue) {
                updateLabelsMedicare(newValue, oldValue);
                updateLabelsPreviousFund(newValue, oldValue);

            }

            function updateLabelsMedicare(newValue, oldValue) {
                if (isSingle()) {
                    $scope.field.cover.medicareEligibility.label = 'Are you eligible for Medicare?';
                }
                else {
                    $scope.field.cover.medicareEligibility.label = 'Are all people to be insured eligible for Medicare?';
                }
            }

            function updateLabelsPreviousFund(newValue, oldValue) {
                if ((isFamily() || isCouple() || isSingleParent()) && $scope.model.personal.previousFundAllSame === 'N') {
                    $scope.field.personal.memberPreviousFundName.label = 'Your Previous Fund Name';
                }
                else {
                    $scope.field.personal.memberPreviousFundName.label = 'Previous Fund Name';
                }
            }

            function updateHospitalCoverLink() {
                var item = _.find($scope.field.cover.hospitalCover.options, {value: $scope.model.cover.hospitalCover});
                if (typeof item !== 'undefined' && item.link !== null) {
                    if (typeof item.link.Url === 'string') {
                        $scope.field.cover.hospitalCover.link.href = item.link.Url;
                        $scope.field.cover.hospitalCover.link.show = true;
                        return true;
                    }
                }
                if (typeof item !== 'undefined' && item.modalId > 0) {
                    $scope.field.cover.hospitalCover.modal.id = item.modalId;
                    $scope.field.cover.hospitalCover.modal.show = true;
                    return true;
                }
                $scope.field.cover.hospitalCover.link.href = '';
                $scope.field.cover.hospitalCover.link.show = false;
                $scope.field.cover.hospitalCover.modal.id = 0;
                $scope.field.cover.hospitalCover.modal.show = false;
                return false;
            }

            function updateExtrasCoverLink() {
                var item = _.find($scope.field.cover.extrasCover.options, {value: $scope.model.cover.extrasCover});
                if (typeof item !== 'undefined' && item.link !== null) {
                    if (typeof item.link.Url === 'string') {
                        $scope.field.cover.extrasCover.link.href = item.link.Url;
                        $scope.field.cover.extrasCover.link.show = true;
                        return true;
                    }
                }
                if (typeof item !== 'undefined' && item.modalId > 0) {
                    $scope.field.cover.extrasCover.modal.id = item.modalId;
                    $scope.field.cover.extrasCover.modal.show = true;
                    return true;
                }
                $scope.field.cover.extrasCover.link.href = '';
                $scope.field.cover.extrasCover.link.show = false;
                $scope.field.cover.extrasCover.modal.id = 0;
                $scope.field.cover.extrasCover.modal.show = false;
                return false;
            }

            function updateFieldOptions(newValue, oldValue) {
                updateHospitalCoverLink();
                updateExtrasCoverLink();

                var isRebateTierChanged = newValue.cover.governmentRebateIncomeTier !== oldValue.cover.governmentRebateIncomeTier;
                if(isRebateTierChanged) {
                    $scope.resetRebateForm();
                }

                if ($scope.model.cover.emergencyAmbulance === 'Y') {
                    $scope.field.payment.paymentFrequency.options = _.filter(joinFormPageData.frequency, function (o) {
                        return (o.value === 'Yearly');
                    });
                }
                else {
                    $scope.field.payment.paymentFrequency.options = angular.copy(joinFormPageData.frequency);
                }

                if (isSingle()) {
                    $scope.field.cover.governmentRebateIncomeTier.options = joinFormPageData.incomeSingle;
                }
                else {
                    $scope.field.cover.governmentRebateIncomeTier.options = joinFormPageData.incomeFamily;
                }


                // Update the options available in the hospital cover and extras cover sections
                $scope.field.cover.hospitalCover.options = angular.copy(joinFormPageData.hospitalCover);
                $scope.field.cover.extrasCover.options = _.filter(joinFormPageData.extrasCover, function (o) {
                    return (o.value != 'Amb');
                });
                if ($scope.model.cover.hospitalCover === 'NOHOSPITAL') {
                    if ($scope.model.cover.extrasCover === 'NOEXTRAS') {
                        $scope.model.cover.extrasCover = 'Anc';
                    }
                    $scope.field.cover.extrasCover.options = _.filter($scope.field.cover.extrasCover.options, function (item) {
                        var result = true;
                        if (item.value === 'NOEXTRAS') {
                            result = false;
                        }
                        return result;
                    });
                }

                // Remove StartPak Options if the extended field is flagged.
                if ($scope.model.cover.nonStudentDependant === 'Y') {

                    $scope.field.cover.hospitalCover.options = _.filter($scope.field.cover.hospitalCover.options, function (item) {
                        var result = true;
                        if (item.value === 'SP') {
                            result = false;
                        }
                        return result;
                    });
                    $scope.field.cover.extrasCover.options = _.filter($scope.field.cover.extrasCover.options, function (item) {
                        var result = true;
                        if (item.value === 'SPAnc') {
                            result = false;
                        }
                        return result;
                    });
                }
            }


            function updateValidationRules(newValue, oldValue) {
                ///////////////////////////////////////////////////////////////
                // Step 1 - Set the validation rules by membership type.
                ///////////////////////////////////////////////////////////////
                if (isSingle()) {
                    $scope.validationRules.cover.partnerDOB = [];
                    $scope.validationRules.personal.partner.partnerTitle = [];
                    $scope.validationRules.personal.partner.partnerRelationship = [];
                    $scope.validationRules.personal.partner.partnerFirstName = [];
                    $scope.validationRules.personal.partner.partnerLastName = [];
                    $scope.validationRules.personal.partner.partnerDOB = [];
                    $scope.validationRules.personal.partner.partnerGender = [];
                    $scope.validationRules.personal.partner.partnerPreviousFundSwitching = [];
                    $scope.validationRules.personal.partner.partnerPreviousFundName = [];
                    $scope.validationRules.personal.previousFundAllSame = [];
                }

                if (isCouple()) {
                    $scope.validationRules.cover.partnerDOB = ['required', 'thfDateOfBirth'];
                    $scope.validationRules.personal.partner.partnerTitle = ['required'];
                    $scope.validationRules.personal.partner.partnerRelationship = ['required'];
                    $scope.validationRules.personal.partner.partnerFirstName = ['required'];
                    $scope.validationRules.personal.partner.partnerLastName = ['required'];
                    $scope.validationRules.personal.partner.partnerDOB = ['required', 'thfDateOfBirth'];
                    $scope.validationRules.personal.partner.partnerGender = ['required'];
                    $scope.validationRules.personal.partner.partnerPreviousFundSwitching = ['required'];
                    $scope.validationRules.personal.partner.partnerPreviousFundName = ['required'];
                    $scope.validationRules.personal.previousFundAllSame = ['required'];
                }

                if (isFamily()) {
                    $scope.validationRules.cover.partnerDOB = ['required', 'thfDateOfBirth'];
                    $scope.validationRules.personal.partner.partnerTitle = ['required'];
                    $scope.validationRules.personal.partner.partnerRelationship = ['required'];
                    $scope.validationRules.personal.partner.partnerFirstName = ['required'];
                    $scope.validationRules.personal.partner.partnerLastName = ['required'];
                    $scope.validationRules.personal.partner.partnerDOB = ['required', 'thfDateOfBirth'];
                    $scope.validationRules.personal.partner.partnerGender = ['required'];
                    $scope.validationRules.personal.partner.partnerPreviousFundSwitching = ['required'];
                    $scope.validationRules.personal.partner.partnerPreviousFundName = ['required'];
                    $scope.validationRules.personal.previousFundAllSame = ['required'];
                }

                if (isSingleParent()) {
                    $scope.validationRules.cover.partnerDOB = [];
                    $scope.validationRules.personal.partner.partnerTitle = [];
                    $scope.validationRules.personal.partner.partnerRelationship = [];
                    $scope.validationRules.personal.partner.partnerFirstName = [];
                    $scope.validationRules.personal.partner.partnerLastName = [];
                    $scope.validationRules.personal.partner.partnerDOB = [];
                    $scope.validationRules.personal.partner.partnerGender = [];
                    $scope.validationRules.personal.partner.partnerPreviousFundSwitching = [];
                    $scope.validationRules.personal.partner.partnerPreviousFundName = [];
                    $scope.validationRules.personal.previousFundAllSame = ['required'];
                }

                ///////////////////////////////////////////////////////////////
                // Step 2 - Override the validation rules defined above by the type.
                ///////////////////////////////////////////////////////////////

                // Turn the medicare validation on and off depending on the state of the government rebate.
                if ($scope.model.cover.governmentRebate === 'Y') {
                    $scope.validationRules.personal.medicareNumber = ['required', 'medicare'];
                    $scope.validationRules.personal.medicareFirstName = ['required'];
                    $scope.validationRules.personal.medicareLastName = ['required'];
                    $scope.validationRules.personal.medicareExpiry = ['required'];
                    $scope.validationRules.confirm.declareRebate = ['required', 'requiredCheckbox'];
                }
                else if (
                    $scope.model.cover.medicareEligibility === 'N'
                    || $scope.model.cover.governmentRebate === 'N'
                    || $scope.model.cover.governmentRebate === ''
                ) {
                    $scope.validationRules.personal.medicareNumber = [];
                    $scope.validationRules.personal.medicareFirstName = [];
                    $scope.validationRules.personal.medicareLastName = [];
                    $scope.validationRules.personal.medicareExpiry = [];
                    $scope.validationRules.confirm.declareRebate = [];
                }

                // Previous Fund Switching
                if ($scope.model.personal.memberPreviousFundSwitching === 'Y') {
                    $scope.validationRules.personal.memberPreviousFundName = ['required'];
                }
                else if ($scope.model.personal.memberPreviousFundSwitching === 'N') {
                    $scope.validationRules.personal.memberPreviousFundName = [];
                }

                // Set the validation when the partner previous fund is switching or not.
                if (isCouple() || isFamily()) {
                    // Partner
                    if ($scope.model.personal.partner.partnerPreviousFundSwitching === 'Y') {
                        $scope.validationRules.personal.partner.partnerPreviousFundName = ['required'];
                    }
                    else if ($scope.model.personal.partner.partnerPreviousFundSwitching === 'N') {
                        $scope.validationRules.personal.partner.partnerPreviousFundName = [];
                    }
                }

                // Iterate over dependants and swap out the validation rules for previous fund switching and for 
                // setting the tertiary education field to mandatory or non mandatory.
                var numDependants = $scope.model.personal.dependants.length;
                if (numDependants > 0) {
                    for (var i = 0; i < numDependants; i++) {
                        var dependant = $scope.model.personal.dependants[i];
                        if (dependant.dependantPreviousFundSwitching === 'Y') {
                            $scope.validationRules.personal.dependants[i].dependantPreviousFundName = ['required']; 
                        }
                        else if (dependant.dependantPreviousFundSwitching === 'N') {
                            $scope.validationRules.personal.dependants[i].dependantPreviousFundName = [];
                        }
                        
                        if(dependant.dependantTertiary === 'Y') {
                            $scope.validationRules.personal.dependants[i].dependantTertiaryInstitute = ['required'];
                        }
                        else if(dependant.dependantTertiary === 'N') {
                            $scope.validationRules.personal.dependants[i].dependantTertiaryInstitute = [];
                        }
                        
                    }
                }


                // Contact Tab
                if ($scope.model.contact.postalAddressSameAsHome === 'Y') {
                    $scope.validationRules.contact.postalAddress = [];
                }
                else if ($scope.model.contact.postalAddressSameAsHome === 'N') {
                    $scope.validationRules.contact.postalAddress = ['required', 'thfPreValidated'];
                }


                // Payment Tab
                if ($scope.model.payment.benefitsSameAsAbove === 'Y') {
                    $scope.validationRules.payment.benefitsAccountName = [];
                    $scope.validationRules.payment.benefitsAccountNumber = [];
                    $scope.validationRules.payment.benefitsAccountBSB = [];
                }
                else if ($scope.model.payment.benefitsSameAsAbove === 'N') {
                    $scope.validationRules.payment.benefitsAccountName = ['required'];
                    $scope.validationRules.payment.benefitsAccountNumber = ['required', 'thfAccountNumber'];
                    $scope.validationRules.payment.benefitsAccountBSB = ['required'];
                }


                if ($scope.model.confirm.howDidYouHear === 'other') {
                    $scope.field.confirm.howDidYouHearSpecify.validation = ['required'];
                }
                else {
                    $scope.field.confirm.howDidYouHearSpecify.validation = [];
                }

                // If the user is a BDO we want to disable certain fields from being active.
                // if(THF.Utility.Location.queryParam('bdo') !== '') {
                //     // Disable Medicare
                //     $scope.validationRules.personal.medicareNumber = [];
                //     $scope.validationRules.personal.medicareFirstName = [];
                //     $scope.validationRules.personal.medicareLastName = [];
                //     $scope.validationRules.personal.medicareExpiry = [];
                //     $scope.validationRules.confirm.declareRebate = [];
                //
                //     // Disable the validation for the account details and benefits payments
                //     $scope.validationRules.payment.paymentAccountName = [];
                //     $scope.validationRules.payment.paymentAccountNumber = [];
                //     $scope.validationRules.payment.paymentAccountBSB = [];
                //     $scope.validationRules.payment.paymentFrequency = [];
                //     $scope.validationRules.payment.paymentInitialDeductionDate = [];
                //     $scope.validationRules.payment.agreeDirectDebit = [];
                //     $scope.validationRules.payment.benefitsAccountName = [];
                //     $scope.validationRules.payment.benefitsAccountNumber = [];
                //     $scope.validationRules.payment.benefitsAccountBSB = [];
                // }

            }

            function hideShowFormFields(newValue, oldValue) {

                // Eligibility Tab Options
                // ------------------------------------------------------------
                $scope.tabs.eligibility.pageActions.nextButton = false;
                $scope.displayGroups.eligibilityNotQualified = false;
                $scope.displayGroups.eligibilityUnionsDropdown = false;
                $scope.validationRules.eligibility.union = [];
                $scope.validationRules.eligibility.formerMember = [];
                $scope.validationRules.eligibility.familyMember = [];
                $scope.model.eligibility.readCriteria = '';

                if ($scope.model.eligibility.currentMember === 'Y') {
                    $scope.displayGroups.eligibilityUnionsDropdown = true;
                    $scope.validationRules.eligibility.union = ['required'];
                    $scope.displayGroups.eligibilityFormerMember = false;
                    $scope.displayGroups.eligibilityFamilyMember = false;
                    $scope.tabs.eligibility.pageActions.nextButton = true;
                    $scope.model.eligibility.readCriteria = 'Y';
                    $scope.model.eligibility.formerMember = '';
                    $scope.model.eligibility.familyMember = '';
                }
                else if ($scope.model.eligibility.currentMember === 'N') {
                    $scope.displayGroups.eligibilityFormerMember = true;
                    $scope.validationRules.eligibility.formerMember = ['required'];
                    $scope.displayGroups.eligibilityFamilyMember = false;

                    if ($scope.model.eligibility.formerMember === 'Y') {
                        $scope.displayGroups.eligibilityUnionsDropdown = true;
                        $scope.validationRules.eligibility.union = ['required'];
                        $scope.displayGroups.eligibilityFamilyMember = false;
                        $scope.tabs.eligibility.pageActions.nextButton = true;
                        $scope.model.eligibility.readCriteria = 'Y';
                        $scope.model.eligibility.familyMember = '';
                    }
                    else if ($scope.model.eligibility.formerMember === 'N') {
                        $scope.displayGroups.eligibilityFamilyMember = true;

                        if ($scope.model.eligibility.familyMember === 'Y') {
                            $scope.tabs.eligibility.pageActions.nextButton = true;
                            $scope.model.eligibility.readCriteria = 'Y';
                        }
                        else if ($scope.model.eligibility.familyMember === 'N') {                            
                            $scope.model.eligibility.readCriteria = 'Y';
                        }
                    }
                }

                // If the user is a BDO we want to disable certain buttons from being active.
                // if(THF.Utility.Location.queryParam('bdo') !== '') {
                //     $scope.tabs.confirm.pageActions.submitButton = false;
                //     $scope.tabs.confirm.pageActions.saveButton = true;
                //     $scope.tabs.confirm.pageActions.saveProgress = false;
                // }

                if ($scope.displayGroups.eligibilityFamilyMember) {
                    $scope.validationRules.eligibility.familyMember = ['required'];
                }

                if (!$scope.displayGroups.eligibilityUnionsDropdown) {
                    $scope.model.eligibility.union = '';
                }

                // IF all are answered in the negative then we want to show the not qualified message.
                if (
                    $scope.model.eligibility.currentMember === 'N'
                    && $scope.model.eligibility.formerMember === 'N'
                    && $scope.model.eligibility.familyMember === 'N'
                ) {
                    $scope.displayGroups.eligibilityNotQualified = true;
                }

                // Emergency Ambulance
                // ------------------------------------------------------------

                if ($scope.model.cover.emergencyAmbulance === 'Y') {
                    $scope.displayGroups.hospitalExtrasCover = false;
                    //$scope.model.cover.hospitalCover = 'NOHOSPITAL';
                    //$scope.model.cover.extrasCover = 'NOEXTRAS';
                    $scope.model.payment.paymentFrequency = 'Yearly';
                }
                else if ($scope.model.cover.emergencyAmbulance === 'N') {
                    $scope.displayGroups.hospitalExtrasCover = true;
                    //$scope.model.cover.hospitalCover = 'TH';
                    //$scope.model.cover.extrasCover = 'Anc';
                    $scope.model.cover.emergencyAmbulance = '';
                    $scope.model.payment.paymentFrequency = 'Fortnightly';
                }

                // Non Student Dependents
                if ($scope.model.cover.nonStudentDependant === 'Y') {

                    // If we have starterpak selected we need to select new available options.
                    if ($scope.model.cover.hospitalCover === 'SP') {
                        $scope.model.cover.hospitalCover = 'BasHo';
                    }
                    if ($scope.model.cover.extrasCover === 'SPAnc') {
                        $scope.model.cover.extrasCover = 'EHC';
                    }

                    if ($scope.model.cover.emergencyAmbulance === 'Y') {
                        $scope.model.cover.hospitalCover = 'BasHo';
                        $scope.model.cover.extrasCover = 'EHC';
                        $scope.model.cover.emergencyAmbulance = 'N';
                    }
                    $scope.displayGroups.emergencyAmbulance = false;
                }
                else {
                    $scope.displayGroups.emergencyAmbulance = true;
                }


                // Continuous Cover Checkboxes
                // ------------------------------------------------------------

                if ($scope.model.cover.emergencyAmbulance === 'Y') {
                    $scope.model.personal.memberContinuousCover = 'N';
                    $scope.model.personal.partnerContinuousCover = 'N';
                    $scope.displayGroups.continuousCoverMember = false;
                    $scope.displayGroups.continuousCoverPartner = false;
                }
                else if ($scope.model.cover.hospitalCover === 'NOHOSPITAL') {
                    $scope.model.personal.memberContinuousCover = 'N';
                    $scope.model.personal.partnerContinuousCover = 'N';
                    $scope.displayGroups.continuousCoverMember = false;
                    $scope.displayGroups.continuousCoverPartner = false;
                }
                else {
                    var coverStartDate = moment($scope.model.coverStartDate).hour(0).minute(0).second(0);
                    if ($scope.model.cover.memberDOB >= '1934-07-01') {
                        var memberLHCBaseDate = THF.Utility.DateHelper.getLHCBaseDate($scope.model.cover.memberDOB);


                        $scope.displayGroups.continuousCoverMember = ( coverStartDate.unix() >= memberLHCBaseDate.unix() );
                        if ($scope.displayGroups.continuousCoverMember) {

                            // On the first setting of the date of birth we need to auto populate this to true.
                            if ($scope.model.personal.memberContinuousCover === '') {
                                $scope.model.personal.memberContinuousCover = 'Y';
                            }
                        }
                        else {
                            if ($scope.model.personal.memberContinuousCover === 'Y') {
                                $scope.model.personal.memberContinuousCover = 'N';
                            }
                        }
                    }
                    else {
                        $scope.displayGroups.continuousCoverMember = false;
                        $scope.model.personal.memberContinuousCover = 'N';
                    }

                    if (isCouple() || isFamily()) {
                        if ($scope.model.cover.partnerDOB >= '1934-07-01') {
                            var partnerLHCBaseDate = THF.Utility.DateHelper.getLHCBaseDate($scope.model.cover.partnerDOB);
                            $scope.displayGroups.continuousCoverPartner = (coverStartDate.unix() >= partnerLHCBaseDate.unix());

                            // On the first setting of the date of birth we need to auto populate this to true.
                            if ($scope.displayGroups.continuousCoverPartner) {
                                if ($scope.model.personal.partnerContinuousCover === '') {
                                    $scope.model.personal.partnerContinuousCover = 'Y';
                                }
                            } else {
                                if ($scope.model.personal.partnerContinuousCover === 'Y') {
                                    $scope.model.personal.partnerContinuousCover = 'N';
                                }
                            }
                        }
                        else {
                            $scope.displayGroups.continuousCoverPartner = false;
                            $scope.model.personal.partnerContinuousCover = 'N';
                        }
                    }
                    else {
                        $scope.displayGroups.continuousCoverPartner = false;
                        $scope.model.personal.partnerContinuousCover = 'N';
                    }

                }

                /**
                 *
                 *
                 * PREVIOUS POLICY HIDE AND SHOW OF FIELDS
                 *
                 *
                 */

                var isMemberSwitching = ($scope.model.personal.memberPreviousFundSwitching === 'Y');
                $scope.displayGroups.memberPreviousPolicyAllSame = ((isCouple() || isFamily() || isSingleParent()) && (isMemberSwitching));

                if (!isMemberSwitching) {
                    $scope.model.personal.previousFundAllSame = 'N';
                }

                $scope.displayGroups.memberPreviousPolicySwitching = true;
                if ($scope.model.personal.memberContinuousCover === 'Y') {
                    $scope.displayGroups.memberPreviousPolicySwitching = false;
                }

                if ($scope.model.personal.previousFundAllSame === 'Y') {
                    $scope.displayGroups.partnerPreviousPolicySwitching = false;
                    //$scope.model.personal.memberPreviousFundSwitching = 'Y'; // So that the member policy fields show.
                    $scope.model.personal.partner.partnerPreviousFundSwitching = 'N'; // So that the partner policy fields hide.
                }
                else {
                    if ($scope.model.personal.memberContinuousCover === 'Y') {
                        $scope.model.personal.memberPreviousFundSwitching = 'Y';
                        $scope.model.personal.memberPreviousFund = '';
                    }

                    $scope.displayGroups.partnerPreviousPolicySwitching = true;
                    if ($scope.model.personal.partnerContinuousCover === 'Y') {
                        $scope.model.personal.partner.partnerPreviousFundSwitching = 'Y';
                        $scope.model.personal.partner.partnerPreviousFund = '';
                        $scope.displayGroups.partnerPreviousPolicySwitching = false;
                    }
                }

                $scope.displayGroups.memberPreviousPolicyFields = ( $scope.model.personal.memberPreviousFundSwitching === 'Y' );
                $scope.displayGroups.partnerPreviousPolicyFields = ( $scope.model.personal.partner.partnerPreviousFundSwitching === 'Y' );

                $scope.displayGroups.howDidYouHearSpecify = ($scope.model.confirm.howDidYouHear === 'other');

                // Hide and show various fields for dependants.
                var numDependants = $scope.model.personal.dependants.length;
                if (numDependants > 0) {
                    for (var i = 0; i < numDependants; i++) {
                        $scope.validationRules.personal.dependants[i] = angular.copy($scope.defaultValidationRules.personal.dependants[0]);

                        var dependant = $scope.model.personal.dependants[i];
                        if (typeof $scope.displayGroups.dependants[i] === 'undefined') {
                            $scope.displayGroups.dependants[i] = {};
                        }

                        if ($scope.model.personal.previousFundAllSame === 'Y') {
                            $scope.displayGroups.dependants[i].dependantPreviousPolicySwitching = false;
                            $scope.displayGroups.dependants[i].dependantPreviousPolicyFields = false;
                        }
                        else {
                            $scope.displayGroups.dependants[i].dependantPreviousPolicySwitching = true;
                            $scope.displayGroups.dependants[i].dependantPreviousPolicyFields = (dependant.dependantPreviousFundSwitching === 'Y');
                        }


                        // Empty the previous fund selected so they start from a blank slate.
                        if (!$scope.displayGroups.dependants[i].dependantPreviousPolicyFields) {
                            $scope.model.personal.dependants[i].dependantPreviousFundSwitching = 'N';
                            $scope.model.personal.dependants[i].dependantPreviousFund = '';
                        }


                        // If the dependant is between 21 and 25 years of age then we need to show the tertiary block
                        var currentAge = THF.Utility.DateHelper.getAge(dependant.dependantDOB, $scope.model.cover.coverStartDate);
                        $scope.displayGroups.dependants[i].dependantTertiary = ( currentAge >= joinFormPageData.dependantMinAge && currentAge <= joinFormPageData.dependantMaxAge );
                        if ($scope.displayGroups.dependants[i].dependantTertiary && dependant.dependantTertiary === '') {
                            dependant.dependantTertiary = 'Y';
                            dependant.dependantTertiaryInstitute = '';
                        }

                        $scope.displayGroups.dependants[i].dependantTertiaryInstitute = ( dependant.dependantTertiary === 'Y' );
                    }
                }


                /**
                 * Hide and show the postal address on the personal tab.
                 */
                if ($scope.model.contact.postalAddressSameAsHome === 'Y') {
                    $scope.displayGroups.postalAddress = false;
                    $scope.model.contact.postalAddress = '';
                }
                else if ($scope.model.contact.postalAddressSameAsHome === 'N') {
                    $scope.displayGroups.postalAddress = true;
                }

                /**
                 *
                 */
                if ($scope.model.payment.benefitsSameAsAbove === 'Y') {
                    $scope.displayGroups.benefits = false;
                    $scope.model.payment.benefitsAccountName = '';
                    $scope.model.payment.benefitsAccountNumber = '';
                    $scope.model.payment.benefitsAccountBSB = '';
                }
                else if ($scope.model.payment.benefitsSameAsAbove === 'N') {
                    $scope.displayGroups.benefits = true;
                }

                /**
                 *
                 *
                 * Various hide and show states based on Member Type
                 *
                 *
                 */
                if (isSingle()) {
                    $scope.displayGroups.extendedCoverCheckbox = false;
                    $scope.displayGroups.partnerFields = false;
                    $scope.displayGroups.dependantFields = false;
                    $scope.model.personal.dependants = [];
                    $scope.model.cover.nonStudentDependant = 'N';
                }

                if (isCouple()) {
                    $scope.displayGroups.extendedCoverCheckbox = false;
                    $scope.displayGroups.partnerFields = true;
                    $scope.displayGroups.dependantFields = false;
                    $scope.model.personal.dependants = [];
                    $scope.model.cover.nonStudentDependant = 'N';
                }

                if (isFamily()) {
                    $scope.displayGroups.extendedCoverCheckbox = true;
                    $scope.displayGroups.partnerFields = true;
                    $scope.displayGroups.dependantFields = true;
                }

                if (isSingleParent()) {
                    $scope.displayGroups.extendedCoverCheckbox = true;
                    $scope.displayGroups.partnerFields = false;
                    $scope.displayGroups.dependantFields = true;
                }

                if (isFamily() || isSingleParent()) {
                    if ($scope.model.personal.dependants.length === 0) {
                        $scope.addNewDependant();
                    }
                }

                // if medicareEligibility === yes then show apply rebateLevel
                $scope.displayGroups.rebateLevel = ( $scope.model.cover.medicareEligibility === 'Y' );
                if (!$scope.displayGroups.rebateLevel) {
                    $scope.model.cover.governmentRebate = 'N';

                }
                $scope.displayGroups.medicareInfo = ( $scope.model.cover.governmentRebate === 'Y' );
            }

            /**
             * Calculates a persons Certified Age of Entry (CAE) for the Loading Health Cover.
             *
             * If the person has had continuous cover then return the age of 30.
             *
             * If the person is under the age of 31 and do not have continuous cover then we do not need
             * to return the age as they are not eligible.
             *
             * Otherwise we need to send back the calculated age of entry.
             *
             * @param dob
             * @param effectiveDate
             * @param continuousCover
             * @returns {*}
             */
            $scope.getLHCAge = function (dob, effectiveDate, continuousCover) {
                return THF.Utility.DateHelper.getLHCAge(dob, effectiveDate, continuousCover);
            };

            function validateTab(tabName, showValidationMessages) {
                showValidationMessages = (typeof showValidationMessages === 'boolean') ? showValidationMessages : true;
                var isValid = thfValidateItems($scope.validationRules[tabName], $scope.field[tabName], $scope.model[tabName], $scope.validation[tabName], $scope.model, $scope.formState, showValidationMessages);
                if (showValidationMessages) {
                    $scope.tabs[tabName].error = (!isValid);
                }
                return isValid;
            }

            $scope.getOptionLabel = function (field, value) {
                var item = _.find(field.options, {value: value});
                if (typeof item !== 'undefined' && item.label) {
                    return item.label;
                }
                return '';
            };

            $scope.getExcess = function () {
                var item = _.find($scope.field.cover.hospitalCover.options, {value: $scope.model.cover.hospitalCover});
                if (typeof item !== 'undefined' && item.excess) {
                    return item.excess;
                }
                return "0";
            };

            $scope.getHospitalTier = function () {
                var item = _.find($scope.field.cover.hospitalCover.options, {value: $scope.model.cover.hospitalCover});
                if (typeof item !== 'undefined' && item.tierName) {
                    return item.tierName;
                }
                return "";
            };

            $scope.getExtrasCoverLabel = function () {
                if ($scope.model.cover.emergencyAmbulance === 'Y') {
                    return 'Emergency Ambulance Only';
                }
                else {
                    return $scope.getOptionLabel($scope.field.cover.extrasCover, $scope.model.cover.extrasCover);
                }
            };

            $scope.resetRebateForm = function() {
                $scope.model.confirm.declareRebate = '';
                $scope.model.confirm.declareInfo = '';
                $scope.field.confirm.declareRebate.disabled = true;
            };

            $scope.fieldActions = {
                openRebateForm: function ($event) {
                    $event.preventDefault();
                    debugLog('Opening Rebate Form Link');
                    rebateFormWindow($scope.model, $scope);
                    $scope.model.confirm.declareRebateError = 'false';
                },
                acceptRebateFormError: function($event) {
                    $event.preventDefault();
                    $scope.displayGroups.rebateError = false;
                    $scope.model.confirm.declareRebateError = 'true';
                }
            };


            /** Tab Controls **/

            /**
             * Takes the user to a specific tab as identified by its name.
             *
             * @param $event
             * @param tab
             */
            $scope.changeTab = function ($event, tab) {
                debugLog('changeTab: ' + tab);
                $event.preventDefault();

                if(tab === 'cover') {
                    THF.Interface.OfferPopover.open();
                }
                else {
                    THF.Interface.OfferPopover.close();
                }
                

                var isValid = false;
                var tabWithError = '';

                // Just to display the validation state of the current tab.
                validateTab($scope.formState.tab);

                // Check all the tabs up until the clicked tab, and if they
                // are all valid then we can navigate to the tab.
                //if (isValid) {
                var k;
                for (k in $scope.tabs) {
                    if ($scope.tabs.hasOwnProperty(k)) {
                        if (k === tab) {
                            isValid = true;
                            break; // There is no need to check any further.
                        }
                        $scope.detectTabsWithData(k);
                        isValid = validateTab(k);
                        if (!isValid) {
                            tabWithError = k;
                            break;
                        }
                    }
                }

                // }

                function switchTab(tab) {
                    if (tab === 'confirm') {
                        $scope.updateConfirmTable();
                    }

                    angular.element('html,body').animate(
                        {
                            scrollTop: (angular.element('.join-form-container').position().top - 75) // 70 is the quote panel height
                        },
                        150,
                        function () {
                            $scope.tabs[$scope.formState.tab].active = false;
                            $scope.tabs[tab].active = true;
                            $scope.formState.tab = tab;
                            $scope.$apply();
                        });

                    var virtualPage = '';

                    switch (tab) {
                        case 'cover':
                            virtualPage = 'your-cover';
                            break;
                        case 'eligibility':
                            virtualPage = 'eligibility';
                            break;
                        case 'personal':
                            virtualPage = 'personal-details';
                            break;
                        case 'contact':
                            virtualPage = 'contact-details';
                            break;
                        case 'payment':
                            virtualPage = 'payment-details';
                            break;
                        case 'confirm':
                            virtualPage = 'confirm';
                            break;
                    }

                    if (virtualPage !== '') {
                        DSTAPI.track('page', {
                            url: '/join-form/' + virtualPage
                        });
                    }
                }

                if (isValid && typeof $scope.tabs[tab] !== 'undefined') {
                    if (
                        tab !== 'eligibility'
                        && tab !== 'cover'
                        && $scope.formState.display.quotePanel === false
                    ) {
                        $scope.calculateQuote(function () {
                            switchTab(tab);
                            $scope.formState.display.quotePanel = true;
                        });
                    }
                    else {
                        switchTab(tab);
                    }
                }
                else if(!isValid){
                    $scope.setFocusToInvalidField(tabWithError);
                }

                //Add an idle timer for the popup
                if (['personal', 'contact', 'payment', 'confirm'].includes(tab)) {

                    var idleTime = 0;
                    var idleTimeout; // Variable to store timeout ID
                    var hasShownForm = Cookies.get('formOpened');

                    // Reset idle timer on user activity
                    function resetIdleTimer() {
                        idleTime = 0; // Reset idle time
                        clearTimeout(idleTimeout); // Clear the previous timeout
                        startIdleTimer(); // Restart the timer
                    }

                    function startIdleTimer() {
                        idleTimeout = setTimeout(showSaveForm, 30000); // 30 seconds
                    }

                    function showSaveForm() {
                        // Only show the form if it hasn't been shown yet
                        if (!Cookies.get('formOpened')) {
                            $('.btn-form-next[value="saveComplete"]').trigger('click');
                        }
                    }

                    // Monitor user activity
                    $(document).on('click scroll mousemove', function () {
                        resetIdleTimer(); // Reset idle timer on any user activity
                    });
                }
            };
            
            $scope.setFocusToInvalidField = function(tabName){
                setTimeout(function(){                    
                    var errorDivEls = document.querySelectorAll("[data-panel='" + tabName + "'] .field-validation-error:not(.ng-hide)");

                    if (errorDivEls.length > 0) {
                        var errorDivEl = errorDivEls[0];

                        // For normal input
                        var inputEl = errorDivEl.parentElement.querySelector("input.input-validation-error");

                        // For Phone numbers
                        if (!inputEl) {
                            inputEl = errorDivEl.parentElement.querySelector(".input-validation-error input");
                        }

                        // For radios
                        if (!inputEl) {
                            inputEl = errorDivEl.parentElement.querySelector("input");
                        }
                                               
                        if (inputEl && !inputEl.disabled && inputEl.type !== 'hidden') {
                           
                            if(inputEl.type === 'checkbox' 
                                || document.activeElement == inputEl // If element is already has the focus
                            ){                                
                                // It doesn't focus when input is a checkbox or if it is already has the focus
                                //, so we will use scroll
                                scrollIntoViewIfNotVisible(inputEl); 
                            }
                            else{                               
                                inputEl.focus();
                            }                            
                            return;
                        }
                        
                        // For other elements (bootstrap select, cover-select)
                        scrollIntoViewIfNotVisible(errorDivEl);
                        
                    }

                }, 100);
            }

            function scrollIntoViewIfNotVisible(target) { 
                if (target.getBoundingClientRect().bottom > window.innerHeight) {
                    target.scrollIntoView(false);
                }
                
                if (target.getBoundingClientRect().top < 0) {
                    target.scrollIntoView();
                } 
            }

            /**
             * Opens the error modal, the continue later button is optional
             * and is set using the continueType parameter.
             *
             * continueType Parameter Options
             * - 'continue' will show the continue button when showing the error modal.
             * - 'saveModal' will show the save and continue button when showing the error modal.
             *
             * @param {string} label The main title to be shown as the first line.
             * @param {string} description The descirption to appear under the main title.
             * @param {string} continueType (See Above)
             */
            $scope.showErrorModal = function (label, description, continueType) {
                continueType = continueType || '';

                $scope.formState.display.loading = false;
                $scope.formState.display.loadingForm = false;
                $scope.formState.display.loadingSubmission = false;
                $scope.formState.display.loadingSave = false;
                $scope.formState.display.loadingResume = false;

                ngDialog.open({
                    template: 'modal-error',
                    className: 'ngdialog-theme-plain error-modal',
                    controller: ['$scope', function ($scope) {
                        $scope.label = label;
                        $scope.description = description;
                        $scope.continueType = continueType;

                        $scope.onHomepage = function ($event) {
                            $event.preventDefault();
                            window.location = '/';
                        };

                        $scope.onSave = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                            $scope.saveAndCompleteLater($event);
                        };

                        $scope.onContinue = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };

                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: $scope
                });
            };

            $scope.eligibilityCriteria = function ($event) {
                $event.preventDefault();

                ngDialog.open({
                    template: 'modal-eligibility-criteria',
                    className: 'ngdialog-theme-plain eligibility-criteria',
                    controller: ['$scope', function ($scope) {
                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: $scope
                });
            };

            $scope.showRebateTiersModal = function ($event) {
                $event.preventDefault();

                ngDialog.open({
                    template: 'modal-rebate-tiers',
                    className: 'ngdialog-theme-plain rebate-tiers',
                    controller: ['$scope', function ($scope) {


                        $scope.onClose = function ($event) {
                            $event.preventDefault();
                            $scope.closeThisDialog();
                        };
                    }],
                    scope: $scope
                });
            };

            /**
             * Navigates the user to the previous tab.
             *
             * Grabs the name of the previous tab based on the current tab open.
             *
             * @param $event
             */
            $scope.previousTab = function ($event) {
                debugLog('previousTab');
                $event.preventDefault();

                var tabKeys = _.keys($scope.tabs);
                var currentIndex = _.indexOf(tabKeys, $scope.formState.tab);
                if (currentIndex > 0) {
                    currentIndex--;
                    $scope.changeTab($event, tabKeys[currentIndex]);
                }
            };

            /**
             * Navigates the user to the next tab.
             *
             * Grabs the name of the next tab based on the current tab open.
             *
             * @param $event
             */
            $scope.nextTab = function ($event) {
                debugLog('nextTab');
                $event.preventDefault();

                var tabKeys = _.keys($scope.tabs);
                var currentIndex = _.indexOf(tabKeys, $scope.formState.tab);

                var eventSettings = {
                    'cover': {
                        'category': 'Join Form - Your Cover',
                        'action': 'Your Cover Page - Next Clicked'
                    },
                    'eligibility': {
                        'category': 'Join Form - Eligibility',
                        'action': 'Eligibility Page - Next Clicked'
                    },
                    'personal': {
                        'category': 'Join Form - Personal Details',
                        'action': 'Personal Details Page - Next Clicked'
                    },
                    'contact': {
                        'category': 'Join Form - Contact Details',
                        'action': 'Contact Details Page - Next Clicked'
                    },
                    'payment': {
                        'category': 'Join Form - Payment Details',
                        'action': 'Payment Details Page - Next Clicked'
                    },
                    'confirm': {
                        'category': 'Join Form - Confirm Details',
                        'action': 'Confirm Page - Submit Clicked'
                    }
                }

                DSTAPI.track('event', {
                    category: eventSettings[tabKeys[currentIndex]]['category'],
                    action: eventSettings[tabKeys[currentIndex]]['action'],
                    label: eventSettings[tabKeys[currentIndex]]['action']
                });

                if (currentIndex < (tabKeys.length - 1)) {
                    currentIndex++;
                    $scope.changeTab($event, tabKeys[currentIndex]);
                }
            };

            /**
             * Adds a new dependant to the listing.
             *
             * @param $event
             */
            $scope.addNewDependant = function ($event) {
                if ($event) {
                    $event.preventDefault();
                }
                $scope.model.personal.dependants.push({});

                // Add the new validation rules for the new dependant
                $scope.validationRules.personal.dependants.push(angular.copy($scope.defaultValidationRules.personal.dependants[0]));
            };

            /**
             * Removes a dependant.
             *
             * @param $event
             * @param index
             */
            $scope.removeDependant = function ($event, index) {
                $event.preventDefault();
                if (typeof $scope.model.personal.dependants[index] !== 'undefined') {
                    $scope.model.personal.dependants.splice(index, 1)
                }
            };

            /**
             * Shows the unavailable error modal.
             */
            $scope.showErrorUnavailable = function() {
                $scope.showErrorModal('Sorry about this.', 'Our online join journey is currently unavailable. We apologise for the inconvenience and thank you for your patience while we work to restore this service. If you’d like to join over the phone, please call our team on '+ $scope.formState.troubleshootingPhoneNumber +'.');
            };

            function debugLog(msg) {
                if (console && console.log) {
                    console.log('[JoinForm]', msg);
                }
            }

            function hasChanged(oldData, newData, property) {
                // split the property
                var pathSegments = property.split('.');
                var segment;

                var result = false;
                var response = false;

                // check if the property exists in the oldData and the newData
                if (pathSegments.length > 0) {
                    for (var i = 0; i < pathSegments.length; i++) {
                        segment = pathSegments[i];

                        if (typeof oldData[segment] !== 'undefined') {
                            result = true;
                            oldData = oldData[segment];
                        }
                        else {
                            result = false;
                        }

                        if (result && typeof newData[segment] !== 'undefined') {
                            result = true;
                            newData = newData[segment];
                        }
                        else {
                            result = false;
                        }

                        if (!result) {
                            break;
                        }
                    }
                }

                if (result && newData !== oldData) {
                    response = true;
                }
                return response;
            }

            function setFieldOptions(data) {
                $scope.field.personal.memberTitle.options = data.titles;
                $scope.field.personal.partnerTitle.options = data.titles;
                
                $scope.field.personal.memberPreviousFundName.options = data.healthFunds;
                $scope.field.personal.partnerPreviousFundName.options = data.healthFunds;
                $scope.field.personal.dependantPreviousFundName.options = data.healthFunds;

                $scope.field.personal.partnerRelationship.options = data.relationships.partner;
                $scope.field.personal.dependantRelationship.options = data.relationships.dependants;
            }


            angular.element('#master-content > .join-form').css({visibility: 'visible'});

            FieldOptionsModel.all()
                .then(function (data) {
                    $scope.formState.display.loadingForm = false;
                    init(data);
                }, function () {
                    $scope.formState.display.loadingForm = false;
                    $scope.showErrorUnavailable();
                });

        }
    ]);
})(angular, _, jQuery, ResponsiveBootstrapToolkit, Cookies, window);